<template>
    <ModalBase :show-modal="showPendingInvitationsModal" @close-modal="close" :short="true" :narrow="true" :overlay-scrollb="true">
        <template v-slot:titlebar>
          <TitleBar variant-class="title-modal">
            <template v-slot:title>
              <span v-translate>Pending Invitations</span>
            </template>
          </TitleBar>
        </template>
        <template v-slot:maincontent>
            <div v-if="!loading" class="table-container">
                <b-table v-if="items.length" 
                    :items="items" 
                    :fields="fields" 
                    thead-class="d-none" 
                    striped hover>
                    <template #cell(created)="data">
                        {{data.item.created | formatDate}}
                    </template>
                    <template #cell(invite_to_name)="data">
                        <div>{{data.item.invite_to_name}}</div>
                        <div class="email-text">{{data.item.invite_to}}</div>
                    </template>
                    <template #cell(delete_button)="data">
                        <div class="icons-grid">
                            <GekkoButton
                                @click="data.toggleDetails"
                                icon="fa fa-cogs"
                                class="text-info p-0"
                                variant="link"
                                :title="$gettext('View message')"
                            />
                            <GekkoButton
                                @click="resendInvitation(data.item)"
                                icon="fa fa-send"
                                class="p-0"
                                variant="link"
                                :title="$gettext('Resend invitation')"
                            />
                            <GekkoButton
                                @click="deleteInvitation(data.item)"
                                icon="fa fa-trash"
                                class="text-danger p-0"
                                variant="link"
                                :title="$gettext('Delete invitation')"
                            />
                        </div>
                    </template>
                    <template #row-details="row">
                        <span class="message-text">
                            {{row.item.message}}
                        </span>
                    </template>
                </b-table>
                <div v-if="!items.length">
                    <i>{{$gettext('You have no pending invites.')}}</i>
                </div>
            </div>
            <div v-if="loading">
                <b-skeleton-table :rows="10" :columns="4" :table-props="{ bordered: false, striped: true }" :hide-header="true"></b-skeleton-table>
            </div>
        </template>
    </ModalBase>
</template>

<script>
import AccountantsService from "@/store/services/accountants.service";
import ModalBase from "@/components/base_components/ModalBase";
import TitleBar from "@/components/TitleBar";
import GekkoButton from '@/components/GekkoButton';

export default {
    name: "PendingInvitesModal",
    components: {
        ModalBase,
        TitleBar,
        GekkoButton
    },
    data() {
        return {
            showPendingInvitationsModal: false,
            items: [],
            fields: [
                {key: "created", tdClass: "date-cell"},
                {key: "invite_to_name"},
                {key: "delete_button", tdClass: "buttons-cell"}
            ],
            loading: true
        }
    },
    watch: {
        showPendingInvitationsModal(newVal) {
            if (newVal) {
                AccountantsService.getPendingInvites().then((response) => {
                    this.items = response.data;
                    this.loading = false;
                });
            }
        }
    },
    methods: {
        close() {
            this.showPendingInvitationsModal = false;
        },
        deleteInvitation(item) {
            AccountantsService.deleteInvite(item.id).then(() => {
                for (var i = 0; i < this.items.length; i++) {
                    if (this.items[i].id === item.id) {
                        this.items.splice(i, 1);
                        break;
                    }
                }
                this.$store.commit("setAlert", {
                    title: this.$gettext("Success!"),
                    text: this.$gettext("Invite deleted."),
                    variant: "success",
                    duration: 4
                });
				this.$emit("refreshlist", false);
            }).catch(() => {
                this.$store.commit("setAlert", {
                    title: this.$gettext("Error"),
                    text: this.$gettext('Something went wrong.'),
                    variant: "error",
                    duration: 4
                });
            });
        },
        resendInvitation(item) {
            AccountantsService.resendInvite(item.id).then(() => {
                this.$store.commit("setAlert", {
                    title: this.$gettext("Success!"),
                    text: `${this.$gettext("Invite resent to ")} ${item.invite_to_name}.`,
                    variant: "success",
                    duration: 4
                });
            }).catch(() => {
                this.$store.commit("setAlert", {
                    title: this.$gettext("Error"),
                    text: this.$gettext('Something went wrong.'),
                    variant: "error",
                    duration: 4
                });
            });
        }
    }
}
</script>
<style lang="scss" scoped>
@media(max-width: '576px') {
    .table-container {
        overflow-x: auto;
    }
}

.icons-grid {
    display: grid;
    grid-template-columns: auto auto auto;
}

.message-text {
    font-style: italic;
    color: $colorTextSemi;
}

.email-text {
    font-size: 12px;
    color: $colorTextSemi;
}

.delete-icon-color {
    color: $colorDanger;
}

.resend-icon-color {
    color: $colorBrand;
}

.view-message-icon-color {
    color: $colorBlue;
}

.delete-icon-color:hover {
    color: $colorDangerBg;
}

.resend-icon-color:hover {
    color: $colorBrand900;
}

.view-message-icon-color:hover {
    color: $colorBlue800;
}

.action-icon {
    cursor: pointer;
}
</style>

<style>
.date-cell {
    min-width: 120px;
    width: 120px;
    vertical-align: middle !important;
}

.buttons-cell {
    vertical-align: middle !important;
}
</style>

